module.exports = __webpack_public_path__ + "static/media/washingmachine.48d79e7e.svg";